import { SafetyOutlined } from '@ant-design/icons';
import cls from 'classnames';
import styles from '../index.module.scss';

interface LoginMethodItemProps {
  item: {
    value: string;
    label: string;
    securityLevel: string;
    subText: string;
    warning?: string;
  };
  isSelected: boolean;
  onSelect: (item: LoginMethodItemProps['item']) => void;
}

const LoginMethodItem = ({ item, isSelected, onSelect }: LoginMethodItemProps) => {
  return (
    <div
      className={cls(styles.content, isSelected && styles.selected)}
      onClick={() => onSelect(item)}
    >
      <Flex justify="space-between">
        <strong>{item.label}</strong>
        <Tag
          rootClassName={cls(
            styles.securityLevel,
            item.securityLevel === 'High' && styles.high
          )}
          icon={<SafetyOutlined />}
        >
          {item.securityLevel}
        </Tag>
      </Flex>
      <div className={styles.contentText}>
        <span>{item.subText}</span>
        {item.warning && <span className={styles.warning}>{item.warning}</span>}
      </div>
      <Divider style={{ margin: '10px 0' }} />
    </div>
  );
};

export default LoginMethodItem;
